import { apiClient } from "@/services/api";
import { V3 } from "@/services/api/apiPrefix";

/**
 * Busca a configuração de Design System de um ponto de venda (catálogo público).
 *
 * @param {string} pointOfSaleId - ID do ponto de venda
 * @returns {Promise<{ designSystemConfig: Object, pointOfSale: Object }>}
 */
export async function getDesignSystemByPointOfSale(pointOfSaleId) {
  try {
    const { data } = await apiClient.get(
      `${V3}/business/design-system-config/${pointOfSaleId}`,
    );
    if (!data?.success) {
      console.error("Erro ao buscar design system:", data?.message);
      throw new Error(data?.message);
    }

    return data?.response;
  } catch (error) {
    throw error;
  }
}
